export const buddyFaces: Record<string, Record<string, any>> = {
  bear: {
    1: require("../assets/images/AiBuddyImages/BearImagesAI/BearVerySad.png"),
    2: require("../assets/images/AiBuddyImages/BearImagesAI/BearSad.png"),
    3: require("../assets/images/AiBuddyImages/BearImagesAI/BearNeutral.png"),
    4: require("../assets/images/AiBuddyImages/BearImagesAI/BearHappy.png"),
    5: require("../assets/images/AiBuddyImages/BearImagesAI/BearVeryHappy.png"),
  },
  meercat: {
    1: require("../assets/images/AiBuddyImages/MeercatImagesAI/MeercatVerySad.png"),
    2: require("../assets/images/AiBuddyImages/MeercatImagesAI/MeercatSad.png"),
    3: require("../assets/images/AiBuddyImages/MeercatImagesAI/MeercatNeutral.png"),
    4: require("../assets/images/AiBuddyImages/MeercatImagesAI/MeercatHappy.png"),
    5: require("../assets/images/AiBuddyImages/MeercatImagesAI/MeercatVeryHappy.png"),
  },
  robot: {
    1: require("../assets/images/AiBuddyImages/RobotImagesAI/RobotVerySad.png"),
    2: require("../assets/images/AiBuddyImages/RobotImagesAI/RobotSad.png"),
    3: require("../assets/images/AiBuddyImages/RobotImagesAI/RobotNeutral.png"),
    4: require("../assets/images/AiBuddyImages/RobotImagesAI/RobotHappy.png"),
    5: require("../assets/images/AiBuddyImages/RobotImagesAI/RobotVeryHappy.png"),
  },
  dragon: {
    1: require("../assets/images/AiBuddyImages/DragonImagesAI/DragonVerySad.png"),
    2: require("../assets/images/AiBuddyImages/DragonImagesAI/DragonSad.png"),
    3: require("../assets/images/AiBuddyImages/DragonImagesAI/DragonNeutral.png"),
    4: require("../assets/images/AiBuddyImages/DragonImagesAI/DragonHappy.png"),
    5: require("../assets/images/AiBuddyImages/DragonImagesAI/DragonVeryHappy.png"),
  },
  guy: {
    1: require("../assets/images/AiBuddyImages/GuyImagesAI/GuyVerySad.png"),
    2: require("../assets/images/AiBuddyImages/GuyImagesAI/GuySad.png"),
    3: require("../assets/images/AiBuddyImages/GuyImagesAI/GuyNeutral.png"),
    4: require("../assets/images/AiBuddyImages/GuyImagesAI/GuyHappy.png"),
    5: require("../assets/images/AiBuddyImages/GuyImagesAI/GuyVeryHappy.png"),
  },
  girl: {
    1: require("../assets/images/AiBuddyImages/GirlImagesAI/GirlVerySad.png"),
    2: require("../assets/images/AiBuddyImages/GirlImagesAI/GirlSad.png"),
    3: require("../assets/images/AiBuddyImages/GirlImagesAI/GirlNeutral.png"),
    4: require("../assets/images/AiBuddyImages/GirlImagesAI/GirlHappy.png"),
    5: require("../assets/images/AiBuddyImages/GirlImagesAI/GirlVeryHappy.png"),
  },
};
